import {observer} from "mobx-react-lite";
import React, {useCallback} from "react";
import walletBillingHistoryStore from "../../../stores/wallet/wallet-billing-history-store";
import WalletTransactionStore from "../../../stores/wallet/wallet-transaction-store";
import TableRow from "../../../../../components/table/components/table-row/table-row";
import Table from "../../../../../components/table/table";
import DateTimeV2, {DATETIME_VIEW} from "../../../../../components/datetime-v2/datetime-v2";
import { useDateTimeFormattingParams } from "../../../../../hooks/use-datetime-formatting-params";
import TransactionAmount from "./TransactionAmount";
import TransactionDescription from "./TransactionDescription";
import BalanceAfterTransaction from "./BalanceAfterTransaction";
import { createPortal } from "react-dom";
import ReportBoxLayout from "../../../../../components/layouts/report-box-layout/report-box-layout";
import { REPORT_TYPES } from "../../../../../services/api/report-service";
import Report from "../../../../../components/report/report";

interface IWalletBillingHistoryTableProps {
    buttonContainerRef: React.RefObject<HTMLDivElement>;
}


const WalletBillingHistoryTable: React.FC<IWalletBillingHistoryTableProps> = observer(({buttonContainerRef}) => {
    const dateTimeParams = useDateTimeFormattingParams();
    const onGetWalletReportFilters = useCallback(() => ({
        'order_by': walletBillingHistoryStore.sortBy,
        'order_dir': walletBillingHistoryStore.sortDir,
    }), []);

    return (
        <>
        <Table
            isLoading={walletBillingHistoryStore.isLoading}
            pagination={{
                onSetPage: walletBillingHistoryStore.loadPage,
                page: walletBillingHistoryStore.page,
                total: walletBillingHistoryStore.total,
                perPage: walletBillingHistoryStore.perPage
            }}
            sort={{
                onSort: walletBillingHistoryStore.sortData,
                by: walletBillingHistoryStore.sortBy,
                dir: walletBillingHistoryStore.sortDir,
            }}
            columns={[
                {
                    content: 'DATE',
                    sortBy: 'created_at',
                    sortable: true,
                    width: {
                        value: 0.5,
                        type: 'fr'
                    }
                },
                {
                    content: 'TYPE',
                    sortBy: 'type',
                    sortable: true,
                    width: {
                        value: 0.5,
                        type: 'fr'
                    }
                },
                {
                    content: 'DESCRIPTION',
                    width: {
                        value: 1.4,
                        type: 'fr'
                    }
                },
                {
                    content: 'AMOUNT',
                    sortBy: 'amount',
                    sortable: true,
                    width: {
                        value: 0.3,
                        type: 'fr'
                    }
                },
                {
                    content: 'BALANCE',
                    width: {
                        value: 0.3,
                        type: 'fr'
                    }
                }
            ]}
            totalResultsTitle='Transactions'
        >
            {walletBillingHistoryStore.list.map((transaction: WalletTransactionStore) => (
                <TableRow
                    key={transaction.id}
                    cells={[
                        <DateTimeV2 {...dateTimeParams} utcDateString={transaction.createdAt} dateTimeView={DATETIME_VIEW.FULL} />,
                        transaction.typeFormatted,
                        <TransactionDescription transaction={transaction} />,
                        <TransactionAmount transaction={transaction} />,
                        <BalanceAfterTransaction transaction={transaction} />,
                    ]}
                />
            ))}
        </Table>
        {
            buttonContainerRef.current &&
            createPortal(
                <ReportBoxLayout>
                    <Report
                        type={REPORT_TYPES.WALLET}
                        title='report'
                        getReportFilters={onGetWalletReportFilters}
                    />
                </ReportBoxLayout>
            , buttonContainerRef.current)
        }
        </>
    )
});

export default WalletBillingHistoryTable;
